import BaseModel from "../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export class LotProposalEmptyEditModel extends BaseModel {
  proposal_suggestion = false
  proposal_status = false
  new_reserve = false
  new_low = false
  new_high = false
  new_start_price = false
  new_reserve_type = null

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}


export class LotProposalEditModel extends BaseModel {
  proposal_suggestion = null
  proposal_status = null
  proposal_comment = null
  new_reserve = null
  new_low = null
  new_high = null
  new_start_price = null
  new_reserve_type = null


  attributeLabels = {
    proposal_suggestion: i18n.t('Suggestion'),
    proposal_status: i18n.t('Proposal Status'),
    proposal_comment: i18n.t('Comment'),
    new_reserve: i18n.t('New Reserve'),
    new_low: i18n.t('New Low Estimate'),
    new_high: i18n.t('New High Estimate'),
    new_start_price: i18n.t('New Start Price'),
    new_reserve_type: i18n.t('New Reserve Type'),
  };

  attributeTitleHint = {
    proposal_suggestion: i18n.t('Bulk Edit Input Hint'),
    proposal_status: i18n.t('Bulk Edit Input Hint'),
    proposal_comment: i18n.t('Bulk Edit Input Hint'),
    new_reserve: i18n.t('Bulk Edit Input Hint'),
    new_low: i18n.t('Bulk Edit Input Hint'),
    new_high: i18n.t('Bulk Edit Input Hint'),
    new_start_price: i18n.t('Bulk Edit Input Hint'),
    new_reserve_type: i18n.t('Bulk Edit Input Hint'),
  }

  attributePlaceholders = this.attributeLabels;

  rules = {
    new_low: 'min_value:1',
    new_high: 'min_value:1',
    new_start_price: 'min_value:0',
    new_reserve: 'min_value:1'
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
